import { render, staticRenderFns } from "./FormEmployee.vue?vue&type=template&id=627a0647&"
import script from "./FormEmployee.vue?vue&type=script&lang=js&"
export * from "./FormEmployee.vue?vue&type=script&lang=js&"
import style0 from "./FormEmployee.vue?vue&type=style&index=0&id=627a0647&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports